import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import classNames           from 'classnames';

class ButtonInput extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let rowClasses = classNames({
            'has-border': this.props.hasBorder,
            'has-padding': this.props.hasPadding,
        });

        let buttonClasses = classNames({
            'btn': true,
            [`${this.props.classNames}`] : true,
        });

        return (
            <question-row class={rowClasses}>
                <div className="question-main">
                    <a
                        id={this.props.id}
                        className={buttonClasses}
                        href={this.props.target}
                        onClick={this.props.onClickEvent}
                    >
                        {this.props.buttonText}
                    </a>
                </div>
            </question-row>
        );
    }
}

ButtonInput.propTypes = {
    id:             PropTypes.string.isRequired,
    buttonText:     PropTypes.string.isRequired,
    classNames:     PropTypes.string.isRequired,
    target:         PropTypes.string,
    hasBorder:      PropTypes.bool,
    hasPadding:     PropTypes.bool,
    onClickEvent:   PropTypes.func,
};

ButtonInput.defaultProps = {
    classNames: 'btn btn-default',
    target: '#',
    hasBorder: false,
    hasPadding: false,
};

export default ButtonInput;


// WEBPACK FOOTER //
// ./src/components/Fields/ButtonInput.js